import PropTypes from 'prop-types'

import { Box } from '@redriverpress/system'
import { StyledModal } from './Modal'

export default function FloatingActionModal({
  children,
  isOpen,
  onClose,
  actionContent,
  ...props
}) {
  return (
    <StyledModal
      isOpen={isOpen}
      allowScroll={false}
      onEscapeKeydown={onClose}
      onBackgroundClick={onClose}
      {...props}
    >
      <Box px={[3, null, 4]} pt={[3, null, 4]}>
        {children}
      </Box>
      <Box
        px={[3, null, 4]}
        py={3}
        bg='white'
        position='sticky'
        bottom='0'
        boxShadow={2}
        css={`
          border-bottom-left-radius: ${({ theme }) => theme.radii.rounded};
          border-bottom-right-radius: ${({ theme }) => theme.radii.rounded};
        `}
      >
        {actionContent}
      </Box>
    </StyledModal>
  )
}

FloatingActionModal.propTypes = {
  actionContent: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}
